import {
  Icon,
  InternalLinkButton,
  TextEllipsis,
} from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Card, CardContent, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import {
  formattedStartToEndDuration,
  getContactDetailsCompanyLink,
} from '../../../../utils';
import * as Styled from './styles';
import * as SX from './sx';
import type { VolunteerItemProps as Props } from './types';

export const VolunteerItem = memo(({ className, item, index }: Props) => {
  const companyLink = getContactDetailsCompanyLink(item.company);

  return (
    <Card
      className={classnames('VolunteerItem', className)}
      sx={SX.root}
      key={index}
      variant="filled"
      color="default"
    >
      <CardContent padding="extra">
        <Stack direction="row" gap={2}>
          <Styled.Image src={item.company?.logo ?? ''}>
            <Icon sxx={SX.icon} size={21} name="apartment-rounded" />
          </Styled.Image>
          <Stack sx={{ width: '100%' }} gap={0.25}>
            <InternalLinkButton to={companyLink}>
              <Typography
                variant="h6"
                color={item.company?.name ? 'grey.700' : 'grey.400'}
              >
                {item.company?.name ?? 'N/A'}
              </Typography>
            </InternalLinkButton>
            <TextEllipsis
              w="256px"
              variant="body3"
              color="grey.700"
              fontWeight={400}
            >
              {item.role}
            </TextEllipsis>

            {item.date?.start && (
              <Typography variant="body4" color="grey.500">
                {formattedStartToEndDuration(item.date.start, item.date?.end)}
              </Typography>
            )}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
});

VolunteerItem.displayName = 'VolunteerItem';
